import React, {Fragment, useEffect, useState} from 'react';
import { IDocument } from '../../interface/IDocument';
import '../../scss/components/Documentcenter.scss';
import FileItem from './FileItem.tsx';
import VideoItem, { isVideoFile } from './VideoItem.tsx';

interface Item {
    show: boolean;
    level: number;
}

const DocumentsWrapper = ({
    documentList
}: { documentList: IDocument }) => {
    
    const firstWithChildren = Array.isArray(documentList) && documentList.find(
        item => Array.isArray(item.children) && item.children.length > 0
    );
    
    const [activeLevels, setActiceLevels] = useState<Array<string>>(firstWithChildren ? [firstWithChildren.name] : []);
    const [showNested, setShowNested] = useState(firstWithChildren ? {
        [firstWithChildren.name]: {
            show: true,
            level: 0
        }
    } : {});

    const toggleNested = (name:string, level:number) => {
        let x = {};
        if (level !== 0) {
            x = structuredClone(showNested);
        }
        x = {
            ...x,
            [name]: {
                show: x[name] ? !x[name].show : true,
                level: level
            }
        };
        Object.entries(x).reduce((acc: { key: string; value: Item }[], [key, value]:[string,any]) => {
            if ((value.level === level && key !== name) || value.level > level) {
                value.show = false;
                acc.push({ key, value });
            }
            return acc;
        }, []);
        let activeEntriesOnly:Array<any> = [];
        activeEntriesOnly = Object.entries(x).reduce((acc: any, [key, value]:any) => {
            if (value.show) {
                acc.push(key);
            }
            return acc;
        }, []);
        setActiceLevels(activeEntriesOnly);
        setShowNested(x);
    };

    const RecursiveFileList = ({ data, level, show }:{data:IDocument, level:number, show: boolean}) => {
        return (
            <div className={`file-list level-${level - 1} ${show ? 'visible' : ''}`}>
                {Object.entries(data).map((parent:Array<any>) => {
                    return (
                        <React.Fragment key={parent[1].path + '-' + level}>
                            {/* rendering folders */}
                            {!parent[1].is_file && Object.keys(parent[1].children).length > 0 && (
                                <button className={`item accordion-headline${activeLevels.includes(parent[1].name) ? ' active' : ''}`} onClick={() => toggleNested(parent[1].name, level)}>
                                    {parent[1].name}
                                </button>
                            )}
                            {/* rendering empty folder */}
                            {!parent[1].is_file && Object.keys(parent[1].children).length <= 0 && (
                                <button disabled className={`item accordion-headline disabled`}>
                                    {parent[1].name}
                                </button>
                            )}
                            {/* rendering children */}
                            { parent[1].children && Object.keys(parent[1].children).length > 0 && (
                                <RecursiveFileList data={parent[1].children} level={level + 1} show={showNested[parent[1].name] && showNested[parent[1].name].show}/>
                            )}
                        </React.Fragment>
                    );
                })}
                {Object.entries(data).map((parent:Array<any>) => {
                    return (
                        <React.Fragment key={parent[1].path + '-' + level}>
                            {/* rendering video files */}
                            {parent[1].is_file && !parent[1].link && !parent[1].text && parent[1].file_name && isVideoFile(parent[1].file_name) && (
                                <VideoItem item={parent} />
                            )}
                            {/* rendering files */}
                            {parent[1].is_file && !parent[1].link && !parent[1].text && (!parent[1].file_name || !isVideoFile(parent[1].file_name)) && (
                                <FileItem item={parent} />
                            )}
                            {/* Is just Text */}
                            {parent[1].is_file && parent[1].text && !parent[1].link && (
                                <span className='plain-text'>
                                    {parent[1].text}
                                    {parent[1].description ? <span className='filedescription'>- {parent[1].description}</span> : ''}
                                </span>
                            )}
                            {/* Is just a Link */}
                            {parent[1].is_file && parent[1].link && !parent[1].text && (
                                <a className='item document-link' href={parent[1].link} target='_blank'>
                                    {parent[1].name}
                                    {parent[1].description ? <span className='filedescription'>- {parent[1].description}</span> : ''}
                                </a>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    };

    return (
        <>
            {
                documentList && documentList.length <= 0 && (
                    <p>Keine Dokumente gefunden</p>
                )
            }
            <div id="document-list">
                <div className="main-level">
                    {
                        Object.entries(documentList).map((item, outerKey) => {
                            /* Top Level Folder, containing Children */
                            if (!item[1].is_file && Object.keys(item[1].children).length > 0) {
                                return (
                                    <button type='button' key={item[0]} className={`nav-item${activeLevels.includes(item[1].name) ? ' active' : ''}`} onClick={() => toggleNested(item[1].name, 0)}>
                                        {item[1].name}
                                    </button>
                                )
                            }
                            /* Top Level empty Folder */
                            if (!item[1].is_file && Object.keys(item[1].children).length <= 0) {
                                return (
                                    <button type='button' key={item[0]} className={`nav-item disabled`} disabled onClick={() => toggleNested(item[1].name, 0)}>
                                        {item[1].name}
                                    </button>
                                )
                            }
                            return <Fragment key={outerKey}></Fragment>
                        })
                    }
                </div>
                <div className="single-document-list">
                    {
                        Object.entries(documentList).map((item) => {
                            if (!item[1].is_file && item[1].children) {
                                return (
                                    <RecursiveFileList data={item[1].children} level={1} key={item[1].name} show={showNested[item[1].name] && showNested[item[1].name].show}/>
                                )
                            }
                            return '';
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default DocumentsWrapper;